import React from 'react'
import { Routes, Route } from 'react-router-dom'
import ScrollToTop from './components/ScrollToTop'
import Header from './components/Header'
import Footer from './components/Footer'
import Home from './pages/Home'
import ServicePage from './pages/ServicePage'
import GalleryPage from './pages/GalleryPage'
import ContactPage from './pages/ContactPage'
import KagerBrodPage from './pages/KagerBrodPage'

function App() {
  return (
    <>
      {/* Scroll restoration to ensure pages start at the top */}
      <ScrollToTop />
      
      <div className="flex min-h-screen flex-col bg-[#faf9f6] text-[#1c2b21] antialiased selection:bg-[#b89a6c] selection:text-[#faf9f6]">
        {/* Main Header / Navigation */}
        <Header />

        {/* Main Content Area */}
        <main className="flex-grow">
          <Routes>
            {/* Home Route */}
            <Route path="/" element={<Home />} />
            
            {/* Dedicated Gallery Route */}
            <Route path="/galleri" element={<GalleryPage />} />
            
            {/* Dedicated Contact Route */}
            <Route path="/kontakt" element={<ContactPage />} />
            
            {/* Dedicated About Route */}
            <Route path="/om-os" element={<ServicePage />} />

            {/* Dedicated Cakes & Bread Route */}
            <Route path="/kager-og-brod" element={<KagerBrodPage />} />
            
            {/* Dynamic Service Routes */}
            <Route path="/:slug" element={<ServicePage />} />
          </Routes>
        </main>

        {/* Footer */}
        <Footer />
      </div>
    </>
  )
}

export default App
